import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { HammerGestureConfig } from '@angular/platform-browser';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Environment } from '@app/models/environment.model';
import { casinoLobbyCardType } from '@components/casino/casino.model';
import { DEFAULT_ENVIRONMENT } from '@environments/default.envrionment';

export const environment: Environment = {
  ...DEFAULT_ENVIRONMENT,
  isActiveBRSmallWidget: false,
  bRSmallWidgetApiKey: 't-2scmpxcssdmd2222',
  isActiveBRSwipeWidget: false,
  bRSwipeWidgetApiKey: 't-swipe2scmdmd2222',
  production: true,
  mobile: false,
  product: 'p1012',
  inheritProductName: 'p1012',
  projectName: 'Tactic',
  loginredirect: '',
  leftsport: false,
  transactionDialogIsActive: false,
  submitBetModifyControl: false,
  IdleWarningIsActive: false,
  IdleWarningMinutes: 15,
  IsRegisterActive: true,
  assetsPath: 'https://d3qlgrav8cpjr0.cloudfront.net/tactic/online/prod/assets/',
  assetsOnlyProject: false,
  isDarkMode: false,
  contactUrl: '',
  helpUrl: '',
  shopLink: '',
  isNewCashout: false,
  newCashoutUrl: '',
  recaptcha: {
    siteKey: '',
  },
  healthUrl: '',
  supportMail: '',
  tracker_Operator: 'BetRadar',
  tracker_ProviderId: null,
  tracker_GroupId: '',
  tracker_ConfigurationId: '',
  IsBetStopReasonHeader: true,
  IsBetStopReasonMatchRow: true,
  IsBetStopReasonCashout: true,
  currencySymbol: '€',
  instagramUrl: '',
  facebookUrl: '',
  whatsappUrl: '',
  twitterUrl: '',
  idleTime: 60 * 60 * 1000,
  accountLock: false,
  isCashoutInfo: false,
  livePageIsPagination: true,
  sideBannerTopWinner: true,
  isLiveStream: true,
  isVorabSearch: true,
  isMySlipLive: true,
  isOddFormatTypeSelect: true,
  isScannerTicketChecker: true,
  isMostPlayedTicket: false,
  bookBetQrCode: false,
  isCashoutTracker: true,
  isMyTeam: false,
  isJacktimeActive: false,
  isRowSelected: true,
  isOddFav: true,
  teamImageAssetsUrl: 'https://sportsbook-api.s3.eu-central-1.amazonaws.com/teams/',
  isQuickAmount: false,
  isBetSettings: true,
  getTopBets: false,
  translatumProjectId: 95,
  translatumMainProjectId: 42,
  imageLeagueUrl: 'https://sportsbook-api.s3.eu-central-1.amazonaws.com/leauge/',
  imageFlagUrl: 'https://sportsbook-api.s3.eu-central-1.amazonaws.com/flags/',
};

export const countryFilterUrl = '';
export const cdnLink2 = '';
export const oktopayAndroid = '';
export const oktopayApple = '';
export const gglLinkUrl = '';
export const darmstadtHessenUrl = '';
export const trackerUrl = '';
export const sponsorTsvlLink = '';
export const reguleminBonusLink = '';
export const reguleminFreeBonusLink = '';
export const mistrzowskiLink = '';
export const bonusowyLink = '';
export const blogLink = '';
export const happyHoursLink = '';

export const passwordRegex = '^(?=.*[A-Z])(?=.*[!.@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,25}$';
export const FOOTER_TEXT_KEY = {
  addressTextHeader: '',
  addressText: '',
};

export const LANGUAGES = ['en', 'tr', 'de', 'nl', 'ku', 'ar', 'vi', 'es', 'fr', 'el', 'ru', 'pl', 'bg', 'da', 'sr', 'sq', 'pt', 'ro', 'it'];
export const DefaultLangCode = 'en';
export const DefaultLangId = 2;
export const EnableCookieConsent = false;
export const EnableIdleTimer = false;
export const DefaultSlipAmount = 2;
export const EasyPasswordEnabled = true;
export const MinSlipAmount = 1;

export const AvailableCountries = ['ok'];
export const SocketURL = 'https://sck.tbet24.com';
export const CashoutURL = '/api/';

export const LEAGUESLIDER = [
  {
    FileName: 'angular/dist/assets/images/league/premiere.svg',
    route: '/league',
    TourId: '107',
    CatId: '1',
  },
  {
    FileName: 'angular/dist/assets/images/league/Bundesliga_logo.svg',
    route: '/league',
    TourId: '16',
    CatId: '13',
  },
  {
    FileName: 'angular/dist/assets/images/league/LaLiga.svg',
    route: '/league',
    TourId: '128',
    CatId: '15',
  },
  {
    FileName: 'angular/dist/assets/images/league/serie-a-seeklogo.com.svg',
    route: '/league',
    TourId: '236',
    CatId: '14',
  },
  {
    FileName: 'angular/dist/assets/images/league/spor_toto_super_lig_logo.svg',
    route: '/league',
    TourId: '133',
    CatId: '16',
  },
  {
    FileName: 'angular/dist/assets/images/league/Ligue_1_logo.svg',
    route: '/league',
    TourId: '167',
    CatId: '99',
  },
];

export const BOTTOM_NAVBAR_ITEMS = [
  { route: '/home', name: 'Home', id: 2, svgUrl: 't-tipico', count: 0, isCountZeroHide: false },
  { route: '/live', name: 'live', id: 3, svgUrl: 'live_bottom', count: 0, isCountZeroHide: false },
  { route: '/casino/lobby/0/0', name: 'Casino', id: 6, svgUrl: 'live_casino_bottom', count: 0, isCountZeroHide: false },
  { route: '/mybets', name: 'my_bets', id: 4, svgUrl: 'my_bets_bottom', count: 0, isCountZeroHide: false },
  { route: '/betslip', name: 'bet_slip', id: 15, svgUrl: 'my_ticket_bottom', count: 0, isCountZeroHide: false },
];

export const cashbackImage: { [key: string]: string } = {
  image1: '',
  image2: '',
  image3: '',
  image4: '',
  image5Dark: '',
  image5Light: '',
};

export const avsconfig_online = {
  apiUrl: '',
  resourceUrl: '',
  partnerId: '',
  onlineBranchId: 0,
};

export const avsconfig_shop = {
  apiUrl: '',
  resourceUrl: '',
  partnerId: '',
};
export const avsconfig_sow = {
  apiUrl: '',
  resourceUrl: '',
  partnerId: '',
};

export const getStatistic = (LangId, SportId, TournamentId) => {
  return '';
};

export const getHeadToHead = (LangId, SportId, TournamentId, BetradarMatchId) => {
  return '';
};

export const getStatisticPage = LangId => {
  return '';
};

export const getLiveScorePage = LangId => {
  return '';
};

export const getBetGeniusLiveTracker = (BetradarMatchId, LangId, themeParam?) => {
  const theme = themeParam ? themeParam : '';
  const url = '';
  return url;
};

export const getEndedMatchResultsPage = (BetradarMatchId, LangId) => {
  return '';
};

export const setCookie = (name, value, expireDays, path = '') => {
  const d = new Date();
  d.setTime(d.getTime() + expireDays * 1 * 60 * 24 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  const cpath = `; path=/`;
  const domain = '.marko90.com;path=/';
  const domain2 = '.games.marko90.com;path=/';
  const domain3 = '.marko90.com;path=/home';
  const domain4 = '.games.marko90.com;path=/home';
  document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain};`;
  document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain2};`;
  document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain3};`;
  document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain4};`;
  document.cookie = `${name}=${value}; ${expires}${cpath}; `;
};

export const setCookieRegister = (name, value?: any, expireDays?: any, path = ''): any => {
  // default
  return;
};

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatInputModule,
    MatListModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatBottomSheetModule,
    A11yModule,
    DragDropModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    MatProgressBarModule,
  ],
})
export class MaterialImports {}
export class AritaHammerConfig extends HammerGestureConfig {
  overrides = {
    pan: {
      direction: 6,
    },
    pinch: {
      enable: false,
    },
    rotate: {
      enable: false,
    },
  };
}
